import { createContext, useContext, useState } from 'react';

const SubNavContext = createContext();

export function SubNavProvider({ children }) {
    const [subNav, setSubNav] = useState(null);

    return (
        <SubNavContext.Provider value={{ subNav, setSubNav }}>
            {children}
        </SubNavContext.Provider>
    );
}

export function useSubNav() {
    const context = useContext(SubNavContext);
    if (!context) {
        throw new Error('useSubNav must be used within SubNavProvider');
    }
    return context;
}
